import "./css/burgermenu.scss";
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../Logo/Logo";
import { useLanguage } from "../../context/LanguageContext";

const BurgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { translations } = useLanguage();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const body = document.body;
    if (isOpen) {
      body.classList.add("lock-scroll");
    } else {
      body.classList.remove("lock-scroll");
    }
  }, [isOpen]);

  const handleNavLinkClick = () => {
    closeMenu();
  };

  return (
    <div className="burger__container">
      <div className={`burger__menu ${isOpen ? "open" : ""}`}>
        <button className="burger__menu--button" onClick={toggleMenu}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </button>
        <div className="burger__menu--items">
          <ul>
            <li>
              <NavLink
                to="/"
                onClick={handleNavLinkClick}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                {translations.header.home}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/polish-culture"
                onClick={handleNavLinkClick}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                {translations.header.polishCulture}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/legendary-stories"
                onClick={handleNavLinkClick}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                {translations.header.legendaryStories}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/for-foreigners"
                onClick={handleNavLinkClick}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                {translations.header.forForeigners}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about-me"
                onClick={handleNavLinkClick}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                {translations.header.aboutMe}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                onClick={handleNavLinkClick}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                {translations.header.contact}
              </NavLink>
            </li>
          </ul>
          <img src="./img/svg/logo.svg" alt="" />
        </div>
      </div>
    </div>
  );
};

export default BurgerMenu;
